/**
 * Utilitários para adicionar headers customizados nas requisições API
 * Inclui propagação de event_id para dedupe com CAPI
 */

import { EVENT_ID_HEADER } from './pixelConstants';
import { getCurrentEventId } from './pixelTracking';

/**
 * Adiciona event_id ao header de uma requisição
 * @param headers Headers existentes
 * @param eventId Event ID a ser adicionado
 * @returns Headers atualizados
 */
export const addEventIdHeader = (
    headers: Record<string, string> = {},
    eventId?: string | null
): Record<string, string> => {
    if (!eventId) return headers;
    
    return {
        ...headers,
        [EVENT_ID_HEADER]: eventId,
    };
};

/**
 * Obtém headers com event_id para criação de sessão de checkout
 * @param sessionId ID da sessão
 * @returns Headers com event_id
 */
export const getCheckoutSessionHeaders = (sessionId?: string): Record<string, string> => {
    const eventId = getCurrentEventId('initcheckout', sessionId);
    return addEventIdHeader({}, eventId);
};

/**
 * Obtém headers com event_id para finalização de pedido
 * @param orderId ID do pedido
 * @returns Headers com event_id
 */
export const getPurchaseHeaders = (orderId: string): Record<string, string> => {
    const eventId = getCurrentEventId('purchase', orderId);
    return addEventIdHeader({}, eventId);
};

/**
 * Obtém headers com event_id para AddPaymentInfo
 * @param sessionId ID da sessão
 * @returns Headers com event_id
 */
export const getPaymentInfoHeaders = (sessionId?: string): Record<string, string> => {
    const eventId = getCurrentEventId('addpaymentinfo', sessionId);
    return addEventIdHeader({}, eventId);
};

/**
 * Merge headers mantendo event_id se existir
 * @param baseHeaders Headers base
 * @param additionalHeaders Headers adicionais
 * @returns Headers mesclados
 */
export const mergeHeaders = (
    baseHeaders: Record<string, string> = {},
    additionalHeaders: Record<string, string> = {}
): Record<string, string> => {
    return {
        ...baseHeaders,
        ...additionalHeaders,
    };
};
